import { useEffect } from 'react';

import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import Dropdown from './Dropdown';

interface SelectProps {
  [x: string]: any;
  name: string;
  dataTestId?: string;
}

const Select = ({ ...props }: SelectProps) => {
  const [field, meta, helpers] = useField(props);
  const { options } = props;
  const invalid = meta.touched && meta.error ? true : false;
  const { setValue } = helpers;

  useEffect(() => {
    if (
      !props.groupedOptions &&
      props.required &&
      options.length === 1 &&
      options[0].value !== meta.value
    ) {
      setValue(options[0].value);
    }
  }, [options, props.required, props.groupedOptions, meta, setValue]);

  const updateValue = (value: ISelectOption | ISelectOption[]) => {
    if (props.isMulti) {
      setValue(value || []);
    } else {
      setValue((value as ISelectOption)?.value || '');
    }
    props.onChange?.(value);
  };

  const searchForGroupedValue = () => {
    for (const optionGroup of props.options as ISelectGroupedOptions[]) {
      const option = optionGroup.options.find((option) => option.value === field.value);
      if (option) return option;
    }
    return null;
  };

  const decomposeValue = () => {
    if (!field.value) return '';
    else if (props.isMulti) return field.value;
    else if (props.groupedOptions) return searchForGroupedValue();
    else return options.find((option: any) => option.value === field.value) || '';
  };

  return (
    <>
      {props.label && (
        <Form.Label>
          {props.label} {props.required && '*'}
        </Form.Label>
      )}
      <Dropdown
        options={options}
        variant="form"
        name={field.name}
        value={decomposeValue()}
        onChange={(value: ISelectOption | ISelectOption[]) => updateValue(value)}
        placeholder={props.placeholder}
        isDisabled={props.isDisabled}
        isSearchable={props.isSearchable}
        isInvalid={invalid}
        isClearable={props.isClearable}
        useIcon={props.useIcon}
        containerNoWrap={props.containerNoWrap}
        dataTestId={props.dataTestId}
        isMulti={props.isMulti}
        useAvatarNameColor={props.useAvatarNameColor}
        groupedOptions={props.groupedOptions}
        wrapLines={props.wrapLines}
        menuPosition={props.menuPosition}
        menuPlacement={props.menuPlacement}
      />
      {invalid && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default Select;
